import {Nullable} from '@fl/cmsch-fe-library';
import {optEmptyString} from 'ts-opt';

import {getAnimalBrowserLink} from './get-animal-browser-link';

interface ReplaceHuidAndGetBrowserLinkParams {
    huid: Nullable<string>;
    earTag: Nullable<string>;
    childHuid: Nullable<string>;
}

/**
 * Builds a mother-link URL, falling back to the child HUID when the mother HUID is missing.
 *
 * @param params Mother and child identifiers used to resolve the final browser link.
 * @returns The Plemdat animal-browser URL for the resolved identifiers.
 *
 * @example
 * replaceHuidAndGetBrowserLink({huid: null, earTag: 'CZ123456789', childHuid: '98765'});
 */
export const replaceHuidAndGetBrowserLink = (
    {
        huid,
        earTag,
        childHuid,
    }: ReplaceHuidAndGetBrowserLinkParams,
): string => {
    const newHuid = huid ? optEmptyString(huid) : optEmptyString(childHuid);

    return getAnimalBrowserLink({earTag: earTag ?? '', huid: newHuid.orElse('')});
};
